<div class="alert-box">
  <div class="modal-header" style="background-color:  #659EC7;color: white;">
    <h5 class="modal-title" style="color: white;">{{data?.title || 'Confirm'}}</h5>
    @if (!data?.disableClose) {
    <!-- <span aria-hidden="true" style="color:#fff"><i class="pi pi-times" (click)="onCancel()"></i></span> -->
    <h4 (click)="onCancel()" style="color:#fff;cursor: pointer;">X</h4>
    }
  </div>
  <div class="modal-body">
    @if (type == 'CONFIRM') {
    {{data?.message ||'Are you sure want to delete this?'}}
    }
    @if (data?.isFormField && formField.length) {
    <div class="m-2">
      <app-form-generator #basicForm [dynamicValidator]="dynamicValidator || []" (onChangeEvent)="onChange($event)"
        [formData]="formField">
      </app-form-generator>
    </div>
    }

  </div>
  @if (data?.info) {
  <span class="text-info m-2">{{data?.info}}</span>
  }
  <div class="modal-footer">
    <p-button (click)="onCancel()" icon="{{data?.btnCancel?.icon != undefined ? data?.btnCancel?.icon :'pi pi-times'}}"
      size="small" [severity]="data?.btnCancel?.severity  ||'warn'" label="{{data?.btnCancel?.title ||
      'No'}}"></p-button>
    <p-button (click)="onConfirm()" icon="{{data?.btnOK?.icon != undefined ? data?.btnOK?.icon :'pi pi-check-circle'}}"
      [disabled]="data?.isFormField && isValid" size="small" [severity]="data?.btnOK?.severity  || 'success'"
      label="{{data?.btnOK?.title ||'Yes'}}"></p-button>
  </div>
</div>